import Backbone from 'backbone'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import selects from 'scoreboard/components/selects'

// There are times in the app where we'd like to quickly display a loading select
// as we wait for data to come back. The PlaceholderSelect does just that, it's
// a placeholder select which is in a loading state, ready to show when needed.

var PlaceholderSelect = Backbone.View.extend({

	tagName: 'select',

	className: 'placeholder-select',

	render: function() {
		// Making this placeholder select "disabled" so it can't get focus
		// (causes weird rendering problems #20482 #20525)
		this.$el.prop('disabled', true)

		selects(this.$el)

		this.richSelect = this.$('+ .select')
		this.richSelect.find('.select-control').addClass('is-loading')
			.append(`<span class="select-item-after">${loadingDots()}</span>`)

		this.toggle()
		return this
	},

	toggle: function(visible) {
		this.richSelect.toggleClass('is-not-displayed', !visible)
	}
})

export default PlaceholderSelect

PlaceholderSelect.__filename__ = 'components/placeholder-select.js'
